var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createSelector } from '@reduxjs/toolkit';
import { isEmpty } from 'lodash';
import { toast } from 'react-toastify';
import { useAppSelector } from '../../store';
import sendAPIRequest from '../../helpers/api/plugNmeetAPI';
import { CommonResponse, UpdateWaitingRoomMessageReq, } from '../../helpers/proto/plugnmeet_common_api_pb';
const waitingRoomMessageSelector = createSelector(_react_refresh_temp_1 = (state) => { var _a; return (_a = state.session.currentRoom.metadata) === null || _a === void 0 ? void 0 : _a.room_features.waiting_room_features; }, (waiting_room_features) => waiting_room_features === null || waiting_room_features === void 0 ? void 0 : waiting_room_features.waiting_room_msg);
$RefreshReg$(_react_refresh_temp_1, "waitingRoomMessageSelector$createSelector");
const UpdateRoomMessage = () => {
    _react_refresh_temp_3();
    const { t } = useTranslation();
    const waitingRoomMessage = useAppSelector(waitingRoomMessageSelector);
    const [message, setMessage] = useState(waitingRoomMessage !== null && waitingRoomMessage !== void 0 ? waitingRoomMessage : '');
    const updateRoomMsg = async () => {
        if (isEmpty(message)) {
            return;
        }
        const body = new UpdateWaitingRoomMessageReq({
            msg: message,
        });
        const r = await sendAPIRequest('waitingRoom/updateMsg', body.toBinary(), false, 'application/protobuf', 'arraybuffer');
        const res = CommonResponse.fromBinary(new Uint8Array(r));
        if (res.status) {
            toast(t('waiting-room.updated-msg'), {
                type: 'info',
            });
        }
        else {
            toast(t(res.msg), {
                type: 'error',
            });
        }
    };
    return (_jsxs("div", { className: "mb-4 text-right", children: [_jsx("p", { className: "text-sm text-black dark:text-darkText capitalize mb-2 block text-left", children: t('waiting-room.update-waiting-message') }), _jsx("textarea", { value: message, onChange: (e) => setMessage(e.currentTarget.value), className: "border border-solid border-primaryColor/20 dark:border-darkText bg-transparent h-20 w-full block p-3 rounded-xl outline-none text-sm dark:text-darkText" }), _jsx("button", { onClick: updateRoomMsg, className: "py-1 px-6 mt-2 rounded-xl text-white text-sm inline-block mr-0 ml-auto transition ease-in bg-primaryColor hover:bg-secondaryColor", children: t('waiting-room.update-msg') })] }));
};
_react_refresh_temp_2 = UpdateRoomMessage;
$RefreshReg$(_react_refresh_temp_2, "UpdateRoomMessage");
_react_refresh_temp_3(UpdateRoomMessage, "8/0V+SswLtOS3tb2gHl74sxpYi0=", false, () => [useTranslation, useAppSelector]);
export default UpdateRoomMessage;
